/*! article-toc — assign IDs to article h2s + smooth-scroll on TOC clicks */
(function () {
  'use strict';

  function handleize(str) {
    return String(str || '')
      .toLowerCase()
      .normalize('NFKD')
      .replace(/\p{M}/gu, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // Find the article's first genuine prose paragraph.
  //
  // Article content varies: some posts are a flat list of <p>/<h2> siblings,
  // others (Squarespace / page-builder imports) wrap everything in nested block
  // <div>s, and the TOC snippet itself injects a <link>/<script> as siblings of
  // the article body. So we don't inspect direct children — we scan the whole
  // body for the first real paragraph, skipping the TOC's own markup, image /
  // figure captions, and empty spacer <p>s (e.g. <p><br></p>).
  function firstProseParagraph(tocRoot, articleBody) {
    var ps = articleBody.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (tocRoot.contains(p)) continue;                       // inside the TOC itself
      if (p.closest && p.closest('figure')) continue;          // image / figure caption
      if ((p.textContent || '').trim().length === 0) continue; // empty / <br> spacer
      return p;
    }
    return null;
  }

  // Move the TOC from its server-rendered spot (top of the article body) to sit
  // immediately before the first section heading. This keeps the whole intro
  // (lead image + intro paragraph(s)) above the TOC and the sections below it,
  // and works at any nesting depth. Desired order: header → intro → TOC → §1.
  function repositionToc(tocRoot, articleBody) {
    var h2s = articleBody.querySelectorAll('h2');
    for (var j = 0; j < h2s.length; j++) {
      if (!tocRoot.contains(h2s[j])) {
        h2s[j].parentNode.insertBefore(tocRoot, h2s[j]);
        return;
      }
    }
    // Fallback (article has no headings — our TOC normally wouldn't render then):
    // sit immediately after the first real prose paragraph instead.
    var intro = firstProseParagraph(tocRoot, articleBody);
    if (intro) {
      intro.insertAdjacentElement('afterend', tocRoot);
      return;
    }
    // Otherwise leave the TOC where the server rendered it (still revealed below).
  }

  function init() {
    var tocRoot = document.querySelector('[data-article-toc]');
    if (!tocRoot) return;

    var articleBody = document.querySelector('[itemprop="articleBody"]');
    if (!articleBody) return;

    repositionToc(tocRoot, articleBody);
    // Reveal the TOC now that it is in its final position (see article-toc.css:
    // it is hidden until this marker is set to avoid a flash at the top).
    tocRoot.setAttribute('data-toc-positioned', '');

    var h2s = articleBody.querySelectorAll('h2');
    var seen = Object.create(null);

    for (var i = 0; i < h2s.length; i++) {
      var h2 = h2s[i];
      var text = (h2.textContent || '').trim();
      if (!text) continue;
      if (text.toLowerCase() === 'table of contents') continue;

      var base = handleize(text);
      if (!base) continue;

      var slug = base;
      var n = 2;
      while (seen[slug]) {
        slug = base + '-' + n;
        n++;
        if (n > 100) break;
      }
      seen[slug] = true;

      if (!h2.id) h2.id = slug;
    }

    var links = tocRoot.querySelectorAll('[data-toc-link]');
    Array.prototype.forEach.call(links, function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = document.getElementById(decodeURIComponent(href.slice(1)));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', href);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
